import { createElement, Fragment } from "react";

type Replacers = {
  strong?: (chunk: React.ReactNode) => React.ReactNode;
  em?: (chunk: React.ReactNode) => React.ReactNode;
};

type MarkdownProps = {
  children: string;
  replacers?: Replacers;
};

/**
 * A really really basic markdown parser. Accepts replacers, so
 * the caller can style the markdown as they see fit.
 */
const Md = ({ children, replacers = {} }: MarkdownProps) => {
  return createElement(Fragment, {}, ...convertMarkdown(children, replacers).flat());
};

function convertMarkdown(markdown: string, replacers: Replacers): (React.ReactNode | string)[] {
  const boldParts = markdown.split("**");

  if (boldParts.length > 1) {
    return boldParts.map((chunk, index) => {
      const convertedChunk = convertMarkdown(chunk, replacers);
      if (index % 2 === 0) {
        return convertedChunk;
      } else {
        return replacers.strong ? replacers.strong(convertedChunk) : <strong>{convertedChunk}</strong>;
      }
    });
  }

  const emParts = markdown.split("*");

  if (emParts.length > 1) {
    return emParts.map((chunk, index) => {
      const convertedChunk = convertMarkdown(chunk, replacers);
      if (index % 2 === 0) {
        return convertedChunk;
      } else {
        return replacers.em ? replacers.em(convertedChunk) : <em>{convertedChunk}</em>;
      }
    });
  }

  return [markdown];
}

export { Md };
